import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    Box,
    CircularProgress,
    Alert,
    Typography,
    Paper,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import apiService from '../services/api';

export const PublicView: React.FC = () => {
    const { encryptedId } = useParams<{ encryptedId: string }>();
    const [htmlContent, setHtmlContent] = useState<string>('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchPublicTemplate = async () => {
            if (!encryptedId) {
                setError('Invalid template ID');
                setLoading(false);
                return;
            }

            setLoading(true);
            setError('');
            
            try {
                const html = await apiService.getPublicTemplate(encryptedId);
                console.log(html);
                setHtmlContent(html as unknown as string);
            } catch (err: any) {
                setError(err.response?.data?.message || 'Failed to load template');
                console.error('Error fetching public template:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchPublicTemplate();
    }, [encryptedId]);

    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    bgcolor: 'background.default',
                }}
            >
                <CircularProgress size={48} />
            </Box>
        );
    }

    if (error) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    bgcolor: 'background.default',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <FontAwesomeIcon 
                    icon={faExclamationTriangle} 
                    style={{ 
                        fontSize: '3rem',
                        color: '#f57c00',
                        marginBottom: '1rem',
                    }} 
                />
                <Typography variant="h6" color="error">
                    Template Not Found
                </Typography>
                <Typography color="text.secondary">
                    {error}
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                height: '100vh',
                width: '100vw',
                overflow: 'hidden',
                bgcolor: 'background.default',
            }}
        >
            <Box
                component="iframe"
                srcDoc={htmlContent}
                sx={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                }}
            />
        </Box>
    );
};
